module.exports = __webpack_public_path__ + "static/media/revert-dark.b781e04f.svg";